import React from "react";
import {
  Users,
  UserCheck,
  UserX,
  Target,
  Clock3,
  CheckCircle2,
  IndianRupee,
  TrendingUp,
} from "lucide-react";

const MISDashboardCardsSkeleton = () => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-3 gap-5">
      {Array.from({
        length: 9,
      }).map((_, index) => (
        <div
          key={index}
          className="bg-white border border-gray-200 rounded-2xl p-5 animate-pulse"
        >
          <div className="flex justify-between">
            <div className="flex-1">
              <div className="h-3 w-24 bg-gray-200 rounded mb-4" />

              <div className="h-8 w-24 bg-gray-200 rounded" />
            </div>

            <div className="h-12 w-12 bg-gray-200 rounded-xl" />
          </div>
        </div>
      ))}
    </div>
  );
};

const colorMap = {
  red: "bg-red-50 text-red-600",
  green: "bg-green-50 text-green-600",
  blue: "bg-blue-50 text-blue-600",
  orange: "bg-orange-50 text-orange-600",
  purple: "bg-purple-50 text-purple-600",
  emerald: "bg-emerald-50 text-emerald-600",
  rose: "bg-rose-50 text-rose-600",
  indigo: "bg-indigo-50 text-indigo-600",
};

const MISDashboardCards = ({ data, loading }) => {
  if (loading) {
    return <MISDashboardCardsSkeleton />;
  }

  const cards = [
    {
      title: "Total Leads",
      value: data?.totalLeads || 0,
      icon: Users,
      color: "red",
    },

    {
      title: "Active Leads",
      value: data?.activeLeads || 0,
      icon: Target,
      color: "green",
    },

    {
      title: "Won Leads",
      value: data?.wonLeads || 0,
      icon: CheckCircle2,
      color: "emerald",
    },

    {
      title: "Lost Leads",
      value: data?.lostLeads || 0,
      icon: UserX,
      color: "rose",
    },

    {
      title: "Sales Team",
      value: data?.totalUsers || 0,
      icon: UserCheck,
      color: "blue",
    },

    {
      title: "Overdue Followups",
      value: data?.overdueFollowups || 0,
      icon: Clock3,
      color: "orange",
    },

    {
      title: "Today's Followups",
      value: data?.todayFollowups || 0,
      icon: Clock3,
      color: "purple",
    },

    {
      title: "Expected Revenue",
      value: `₹${(data?.expectedRevenue || 0).toLocaleString("en-IN")}`,
      icon: IndianRupee,
      color: "red",
    },

    {
      title: "Estimated Revenue",
      value: `₹${(data?.estimatedRevenue || 0).toLocaleString("en-IN")}`,
      icon: TrendingUp,
      color: "indigo",
    },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-3 gap-5">
      {cards.map((card) => {
        const Icon = card.icon;

        return (
          <div
            key={card.title}
            className="bg-white border border-gray-200 rounded-2xl p-5 shadow-sm hover:shadow-md transition-all"
          >
            <div className="flex items-start justify-between">
              <div>
                <p className="text-sm text-gray-500 font-medium">
                  {card.title}
                </p>

                <h3 className="mt-3 text-2xl font-bold text-gray-900">
                  {card.value}
                </h3>
              </div>

              <div
                className={`h-12 w-12 rounded-xl flex items-center justify-center ${colorMap[card.color]}`}
              >
                <Icon size={22} />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default MISDashboardCards;
